import React from "react";

function Careers() {
  return (
    <>
      <section className="careersSec">
        <div className="container">
          <div className="row ">
            <div className="col-lg-12">
              <div className="careersInfo">
                <div className="fisherman-content">
                  <h3>GGAS OFFERS A WIDE SPECTRUM OF JOB OPPORTUNITIES</h3>
                  <strong>
                    'GGAS' team is its biggest asset. We look for enthusiastic,
                    energetic, flexible team players, who are passionate and
                    enjoy the challenges of working for a rapidly growing global
                    organisation.
                  </strong>
                </div>

                <div className="careersNote mb-2">
                  <p>
                    At GGAS, we believe in the power of our people, and we're
                    always on the lookout for those who want to learn and
                    develop their potential - whilst being part of a
                    multi-national, global team. We seek people with passion,
                    commitment and dedication to take on challenging jobs and
                    accomplish them with determination.
                  </p>
                  <p>
                    Should you wish to submit your CV for consideration, please
                    send it to us on office@GGAS.com
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Careers;
